import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { startAuthFlow } from "../services/oauth";
import Button from "../components/Button";
import { useAuthStore } from "../stores/authStore";

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");
  const errorDescription = searchParams.get("error_description");
  const sessionError = useAuthStore((state) => state.error);
  const clearError = useAuthStore((state) => state.clearError);

  const handleLogin = async () => {
    clearError();
    setIsLoading(true);
    try {
      await startAuthFlow();
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to Ginger CMS
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Access your content management dashboard
          </p>
        </div>

        {(error || sessionError) && (
          <div className="rounded-md bg-red-50 p-4">
            <div className="text-sm text-red-700">
              {errorDescription || sessionError || "Authentication failed"}
            </div>
          </div>
        )}

        <div>
          <Button
            type="button"
            className="w-full"
            disabled={isLoading}
            onClick={handleLogin}
          >
            {isLoading
              ? "Redirecting to secure login..."
              : "Sign in with OAuth"}
          </Button>
        </div>
      </div>
    </div>
  );
}
